import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

const NotFound = () => import(/* webpackChunkName: "notFound" */ "../views/404.vue");
const Login = () => import(/* webpackChunkName: "login" */ "../views/Login.vue");
import {MessageBox} from "element-ui";
import home from "./home";
import eshop from "./eshop";
import integralMall from "./integralMall";
import facilities from "./facilities";
import news from "./news";
import myProfile from "./myProfile";
import otherFacilities from "./otherFacilities";
import informationColumn from "@/router/informationColumn";
import briefIntroduction from "@/router/briefIntroduction";
import room from "@/router/room";

/**
 * route
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
 * leaf: true                      if `leaf:true` will show menu single in the sidebar(default is false)
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    will control the page roles (you can set multiple roles)
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if true, the page will no be cached(default is false)
    breadcrumb: false            if false, the item will hidden in breadcrumb(default is true)
  }
 **/
const routes = [
    {
        path: "/login",
        component: Login,
        name: "",
        hidden: true,
    },
    {
        path: "/",
        redirect: "/home",
        name: "",
        hidden: true,
    },
    {
        path: "/404",
        component: NotFound,
        name: "",
        hidden: true,
    },
    ...home,
    ...briefIntroduction,
    ...eshop,
    ...room,
    ...integralMall,
    ...facilities,
    ...otherFacilities,
    ...news,
    ...informationColumn,
    ...myProfile,
    {
        path: "*",
        redirect: "/404",
        hidden: true,
    },
];

const router = new VueRouter({
    routes,
});

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};
router.beforeEach((to, from, next) => {
    if (to.path == "/login") {
        localStorage.removeItem("WEBTOKEN");
        localStorage.removeItem("webUserInfo");
    }
    const token = localStorage.getItem("WEBTOKEN");
    if (to.meta && to.meta.auth) {
        if (!token) {
            swal({
                title: "提示",
                text: "此操作需要登录, 请先登录",
                icon: "warning",
                buttons: {
                    confirm: {
                        text: "确认",
                        value: true,
                        visible: true,
                        className: "",
                        closeModal: true,
                    },
                },
            }).then((willDelete) => {
                if (willDelete) {
                    const path = router.app.$route.path;
                    let query = router.app.$route.query;
                    query.path = path;
                    next({path: '/login', query});
                } else {
                    swal("Your imaginary file is safe!");
                }
            });
            return;
        }
    }
    next();
});
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
});
export default router;
